"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ActionsMenu = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ = _interopRequireDefault(require("@carbon/icons-react/lib/edit/24.js"));
var _2 = _interopRequireDefault(require("@carbon/icons-react/lib/overflow-menu--horizontal/32.js"));
var _3 = _interopRequireDefault(require("@carbon/icons-react/lib/trash-can/24.js"));
var _4 = _interopRequireDefault(require("@carbon/icons-react/lib/view/24.js"));
var _5 = _interopRequireDefault(require("@carbon/icons-react/lib/view--off/24.js"));
var _ListenOnClickOutside = require("../../common/Listeners/ListenOnClickOutside");
var _Modal = _interopRequireDefault(require("../Modal/Modal"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.actions-menu {\n  position: relative;\n  width: 32px; }\n  .actions-menu:hover {\n    cursor: pointer; }\n  .actions-menu .actions {\n    position: absolute;\n    top: 0;\n    right: 0;\n    background: #4c4c4c;\n    padding: 8px 16px 8px 18px;\n    display: flex; }\n    .actions-menu .actions svg {\n      fill: #fff;\n      margin-right: 16px; }\n      .actions-menu .actions svg:last-child {\n        margin-right: 0; }\n";
  const fileName = "ActionsMenu_ActionsMenu";
  const element = document.querySelector("style[data-sass-component='ActionsMenu_ActionsMenu']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const ActionsMenu = props => {
  const [isOpen, setIsOpen] = (0, _react.useState)(false);
  const [isRemoveModalOpen, setIsRemoveModalOpen] = (0, _react.useState)(false);
  const ref = (0, _react.useRef)(null);
  (0, _ListenOnClickOutside.listenOnClickOutside)(ref, () => setIsOpen(false));
  const renderActions = () => {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: 'actions'
    }, Object.keys(props.actions).map(actionName => {
      const callback = props.actions[actionName];
      if (!callback) {
        return;
      }
      switch (actionName) {
        case 'hide':
          return /*#__PURE__*/_react.default.createElement(_5.default, {
            key: actionName,
            onClick: callback
          });
        case 'show':
          return /*#__PURE__*/_react.default.createElement(_4.default, {
            key: actionName,
            onClick: callback
          });
        case 'change':
          return /*#__PURE__*/_react.default.createElement(_.default, {
            key: actionName,
            onClick: callback
          });
        case 'remove':
          return /*#__PURE__*/_react.default.createElement(_3.default, {
            key: actionName,
            onClick: () => setIsRemoveModalOpen(true)
          });
        default:
          return null;
      }
    }));
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    ref: ref,
    className: 'actions-menu'
  }, /*#__PURE__*/_react.default.createElement(_2.default, {
    onClick: () => setIsOpen(true)
  }), isOpen && renderActions(), isRemoveModalOpen && /*#__PURE__*/_react.default.createElement(_Modal.default, {
    title: props.translate('modal.title.remove', {
      name: props.name
    }),
    lead: props.translate('modal.lead.remove'),
    confirmLabel: props.translate('modal.button.confirm'),
    cancelLabel: props.translate('modal.button.cancel'),
    onConfirm: () => {
      props.actions.remove();
      setIsRemoveModalOpen(false);
      setIsOpen(false);
    },
    onCancel: () => {
      setIsRemoveModalOpen(false);
      setIsOpen(false);
    }
  }));
};
exports.ActionsMenu = ActionsMenu;
ActionsMenu.propTypes = {
  actions: _propTypes.default.object.isRequired,
  translate: _propTypes.default.func.isRequired,
  name: _propTypes.default.string
};
var _default = exports.default = ActionsMenu;